<script>
import { mapState } from "vuex";
import { validateAndSubmit } from "../../../mixins/validateAndSubmit";
import { validationClass } from "../../../mixins/validationClass";
import "vue-slider-component/theme/default.css";

export default {
  data() {
    return {
      form: {
        what_is_most_important: "",
      },
      active: null,
      pending: null,
      completed: null,
      item: {},
      index: 0,
      sortField: "",
      sortOrder: "",
      disableOnSubmit: false,
    };
  },

  props: ["url", "activeUrl", "pendingUrl", "completedUrl", "question"],

  mixins: [validateAndSubmit, validationClass],

  computed: {
    sortActive() {
      return this.sortField != ""
        ? "?field=" + this.sortField + "&order=" + this.sortOrder
        : "";
    },
  },

  created() {
    if (!Array.isArray(this.question)) {
      this.form = this.question;
    }
  },

  mounted() {
    this.getData();
  },

  watch: {},

  methods: {
    getData() {
      this.getActive();
      this.getPending();
      this.getCompleted();
    },

    getActive() {
      axios
        .get(this.activeUrl + this.sortActive)
        .then((response) => {
          this.active = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPending() {
      axios
        .get(this.pendingUrl)
        .then((response) => {
          this.pending = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCompleted() {
      axios
        .get(this.completedUrl)
        .then((response) => {
          this.completed = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    toggleSort(field) {
      this.sortOrder =
        this.sortOrder == "asc" && this.sortField == field ? "desc" : "asc";
      this.sortField = field;
      this.getActive();
    },

    toggleDeleteModal(item, index) {
      this.item = item;
      this.index = index;
      $("#deleteGoalModal").modal("show");
    },

    deleteItem() {
      axios
        .delete(this.item.delete_url)
        .then((response) => {
          if (this.item.active) {
            this.active.splice(this.index, 1);
          } else {
            this.pending.splice(this.index, 1);
          }
          this.$root.$refs.toastr.s(response.data.message);
          $("#deleteGoalModal").modal("hide");
        })
        .catch((error) => {
          console.log(error);
          this.$root.$refs.toastr.e("ERROR");
        });
    },

    deactivateItem(item) {
      axios
        .put(item.deactivate_url)
        .then((response) => {
          this.getActive();
          this.getPending();
          this.$root.$refs.toastr.s(response.data.message);
          $("#deleteGoalModal").modal("hide");
        })
        .catch((error) => {
          console.log(error);
          deactivateError = true;
          this.$root.$refs.toastr.e("ERROR");
        });
    },

    activateItem(item) {
      axios
        .put(item.activate_url)
        .then((response) => {
          this.getActive();
          this.getPending();
          this.$root.$refs.toastr.s(response.data.message);
          $("#deleteGoalModal").modal("hide");
        })
        .catch((error) => {
          console.log(error);
          deactivateError = true;
          this.$root.$refs.toastr.e("ERROR");
        });
    },

    formatDate(date) {
      if (!date) {
        return date;
      }
      var split = date.split("/");
      date = split[2] + "/" + split[1] + "/" + split[0];
      return date;
    },
  },
};
</script>
